import $ from 'jquery';
import Vars from '../../vars';
import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from '../classes/Validation';

class Right {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $request : $(),
        $cancel  : $(),
        $approve : $()
    };

    _const = {
        entities : 'rights',
        entity   : 'right'
    };

    _args = {
        page : '',
        get  : ''
    };

    _state = {
        id       : 0,
        items    : {},
        item     : {},
        objects  : {},
        objectId : 0
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page = args.page || self._args.page;
        self._args.get  = args.get  || self._args.get;
    };

    _bindElements = () => {
        let self = this;

        if (!self._elems.$content.length) self._elems.$content = $('.content');
        if (!self._elems.$content.length) return;

        self._elems.$request = self._elems.$content.find('.js-profile-right-request');
        self._elems.$cancel  = self._elems.$content.find('.js-profile-right-cancel');
        self._elems.$approve = self._elems.$content.find('.js-profile-right-approve');
    };

    _bindRequest = () => {
        let self = this;

        if (!self._elems.$request.length) return;

        self._elems.$request.unbind('click').on('click', function(e){
            e.preventDefault();

            self._state.objectId = parseInt($(this).data('id'));

            new Modal({
                title   : 'Запросить доступ к рекламным материалам',
                content : Utils.renderProfileTemplate('right-object-request'),
                confirm : function(args){
                    self._bindRequestConfirm(args);
                }
            });
        });
    };

    _bindRequestConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        loader.increase();
        Request.send({
            path: '/api/objects/' + self._state.objectId + '/share',
            method: 'POST',
            data: $form.serialize(),
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }

                $modal.trigger('close');

                self._state.object = response.object;
                self._state.objects.data.forEach(function(obj, i){
                    if (obj.id == self._state.object.id) {
                        self._state.objects.data[i].right = self._state.object.right;
                    }
                });

                let data             = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Доступы',
                            href  : '#rights'
                        },
                        {
                            title : 'Поиск ЖК'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-objects', {
                    breadcrumbs : breadcrumbs,
                    objects     : self._state.objects,
                    data        : data
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindCancel = () => {
        let self = this;

        if (!self._elems.$cancel.length) return;

        self._elems.$cancel.unbind('click').on('click', function(e) {
            e.preventDefault();

            self._state.id = parseInt($(this).data('id'));

            new Modal({
                title: 		'Отклонить заявку',
                content: 	Utils.renderProfileTemplate('info', {
                    message   : 'Вы действительно хотите отклонить этот запрос?',
                    buttons : {
                        one : {
                            class : 'confirm button--remove',
                            title : 'Да, отклонить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет, отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    self._bindCancelConfirm(args);
                }
            });
        });
    };

    _bindCancelConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;

        let validation = new Validation({
            form : $modal
        });

        loader.increase();

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._state.id + '/cancel',
            method: 'POST',
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }

                $modal.trigger('close');

                self._state.item = response[self._const.entity];
                self._state.items.forEach(function(item, index){
                    if(item.id == self._state.item.id)
                        self._state.items[index] = self._state.item;
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-inside', {
                    breadcrumbs            : self._state.breadcrumbsInside,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindApprove = () => {
        let self = this;

        if (!self._elems.$approve.length) return;

        self._elems.$approve.unbind('click').on('click', function(e) {
            e.preventDefault();

            self._state.id = parseInt($(this).data('id'));
            self._state.item = self._state.items.filter(function(item){
                return item.id == self._state.id;
            });

            if (!self._state.item.length) return;

            loader.increase();
            Request.send({
                path: '/api/' + self._const.entities + '/' + self._state.id + '/options',
                method: 'POST',

                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    let object        = response.object;
                    let widget_parts  = response.widget_parts;
                    let site_parts    = response.site_parts;

                    new Modal({
                        title: 'Заявка на доступ к рекламным материалам',
                        content: Utils.renderProfileTemplate('right-approve', {
                            object       : object,
                            widget_parts : widget_parts,
                            site_parts   : site_parts,
                            right        : self._state.item[0]
                        }),
                        closingConfirmation: true,
                        confirm : function(args){
                            self._bindApproveConfirm(args);
                        }
                    });
                }
            });
        });
    };

    _bindApproveConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        loader.increase();

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._state.id + '/approve',
            method: 'POST',
            data: $form.serialize(),
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }
                $modal.trigger('close');

                self._state.item = response[self._const.entity];
                self._state.items.forEach(function(item, index){
                    if(item.id == self._state.item.id)
                        self._state.items[index] = self._state.item;
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-inside', {
                    breadcrumbs            : self._state.breadcrumbsInside,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindFilter = () => {
        let self = this;

        let run = false;

        self._elems.$content.find('select[name="object[ids][]"]').selectize({
            theme: 'result',
            valueField: 'id',
            labelField: 'fullname',
            searchField: 'query',
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    if(item.type) {
                        return '<div><span class="title">' + ifacade.constants.objects.types[item.type].short_name + ' «' + item.name + '» <small>(' + ifacade_format_date_short(new Date(item.updated_at.replace(/-/g, '/'))) + ')</small></span></div>';
                    }
                    else {
                        return '<div><span class="title">' + item.fullname + '</span></div>';
                    }
                }
            },
            load: function(query, callback){
                if (query.length < 3) return callback();

                clearTimeout(run);
                run = setTimeout(function(){
                    self._elems.$content.find('.filter__message').addClass('--loading');
                    self._elems.$content.find('.filter__message .loading span').text(query);
                    Request.send({
                        path: '/api/objects/search',
                        method: 'POST',
                        data: {
                            query: query
                        },
                        done: function (response) {
                            self._elems.$content.find('.filter__message').removeClass('--loading');
                            if(!response.objects || response.objects.length == 0) {
                                self._elems.$content.find('.filter__empty span').text(query);
                                self._elems.$content.find('.filter__empty').show();
                            }
                            else {
                                callback(response.objects, response.query);
                                self._elems.$content.find('.filter__empty').hide();
                            }
                        }
                    });
                }, 200);
            },
            onItemAdd: function(value, $item){
                this.blur();
            }
        });

        self._elems.$content.find('.filter__actions button').on('click', function(e){
            e.preventDefault();
            loader.increase();

            if(self._args.get != ''){
                let urlParts = self._args.get.split('?');
                let params = new URLSearchParams(urlParts[1]);
                params.delete('page');
                self._args.get = '?' + params.toString();
                window.history.pushState('right_object', document.title, '/profile#rights/objects');
            }

            Request.send({
                path: '/api/objects/sharing' + self._args.get,
                data: self._elems.$content.find('form').serialize(),
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.objects  = response.objects;
                    let data             = {
                        status          : self._elems.$content.find('select[name="right[status]"]').val(),
                        objects         : response.objects_selected,
                        with_free_flats : response.with_free_flats,
                        is_filtered     : !!(
                            (response.objects_selected && response.objects_selected.length)
                            ||
                            (response.with_free_flats === 1)
                            ||
                            (self._elems.$content.find('select[name="right[status]"]').val() !== '' && self._elems.$content.find('select[name="right[status]"]').val() !== 'Все')
                        )
                    };

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-objects', {
                        breadcrumbs : self._state.breadcrumbsObjects,
                        objects     : self._state.objects,
                        data        : data
                    }));

                    self._bindElements();
                    self._bindUI();
                }
            });
        });

        self._elems.$content.find('.reset').on('click', function (e) {
            e.preventDefault();
            loader.increase();

            Request.send({
                path: '/api/objects/sharing' + self._args.get,
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.objects  = response.objects;
                    let data             = {};

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-objects', {
                        breadcrumbs : self._state.breadcrumbs,
                        objects : self._state.objects,
                        data    : data
                    }));

                    self._bindElements();
                    self._bindUI();
                }
            });
        });

        self._elems.$content.on('click', '.form-field .checkbox', function(e) {
            e.preventDefault();

            let $inputs = $(this).children('input');

            if ($(e.target).is('.checkbox__enable')) {
                $(this).removeClass('disabled');
                $inputs.eq(0).prop('disabled', $(this).hasClass('checked'));
                $inputs.eq(1).prop('disabled', !$(this).hasClass('checked'));
                $(this).trigger('enable').trigger('change');
                return;
            }

            if ($(e.target).is('.checkbox__disable')) {
                $(this).addClass('disabled');
                $inputs.prop('disabled', true);
                $(this).trigger('disable').trigger('change');
                return;
            }

            if ($(this).hasClass('disabled')) return;

            if ($(this).hasClass('checked')) {
                $inputs.eq(0).prop('disabled', false);
                $inputs.eq(1).prop('disabled', true);
                $(this).removeClass('checked');
                $(this).trigger('change');
                $(this).trigger('uncheck');
            }
            else {
                $inputs.eq(0).prop('disabled', true);
                $inputs.eq(1).prop('disabled', false);
                $(this).addClass('checked');
                $(this).trigger('change');
                $(this).trigger('check');
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._bindFilter();
        self._bindRequest();
        self._bindCancel();
        self._bindApprove();
    };

    _list = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/' + self._const.entities + '/counts',
            done: function (response) {
                loader.decrease();
                Utils.scrollToTop();

                const counts = response.counts;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Доступы'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs : self._state.breadcrumbs,
                    inside      : counts.inside,
                    outside     : counts.outside
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _objects = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/objects/sharing' + self._args.get,
            done: function (response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.objects    = response.objects;

                const selected      = response.objects_selected;
                const withFreeFlats = response.with_free_flats;

                let   data             = {
                    objects         : selected,
                    with_free_flats : withFreeFlats,
                    is_filtered     : !!(
                        (selected && selected.length)
                        ||
                        (withFreeFlats === 1)
                        ||
                        ($('select[name="right[status]"]').val() !== undefined && $('select[name="right[status]"]').val() !== '' && $('select[name="right[status]"]').val() !== 'Все')
                    )
                };

                self._state.breadcrumbsObjects = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Доступы',
                            href  : '#rights'
                        },
                        {
                            title : 'Поиск ЖК'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-objects', {
                    breadcrumbs : self._state.breadcrumbsObjects,
                    objects     : self._state.objects,
                    data        : data
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _inside = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/' + self._const.entities + '/inside',
            done: function (response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];

                self._state.breadcrumbsInside = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Доступы',
                            href  : '#rights'
                        },
                        {
                            title : 'Входящие запросы'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-inside', {
                    breadcrumbs            : self._state.breadcrumbsInside,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _outside = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/' + self._const.entities + '/outside',
            done: function (response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Доступы',
                            href  : '#rights'
                        },
                        {
                            title : 'Исходящие запросы'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-outside', {
                    breadcrumbs            : breadcrumbs,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        }
        else if (self._args.page === Vars.page.right.objects) {
            self._objects();
        }
        else if (self._args.page === Vars.page.right.inside) {
            self._inside();
        }
        else if (self._args.page === Vars.page.right.outside) {
            self._outside();
        }
    };
}

export default Right;